import Grid from '@material-ui/core/Grid'
import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

import { FormControl } from '../../../../../../components/Forms'

// Os ids chegam como string (JSON:API) ou número (meta, inscrição salva).
const sameId = (a, b) =>
  a !== undefined && a !== null && b !== undefined && b !== null && `${a}` === `${b}`

const WeakStreetResults = ({
  addresses,
  choose,
  clearStreet,
  disabled,
  neighborhoods,
  selectedNeighborhoodId,
  selectedStreetId,
  selectNeighborhood,
}) => {
  const selectedNeighborhood =
    neighborhoods.find(i => sameId(i.id, selectedNeighborhoodId)) || null

  const streets = selectedNeighborhoodId
    ? addresses.filter(street =>
        sameId(street.neighborhoodId, selectedNeighborhoodId)
      )
    : []

  const selectedStreet = streets.find(i => sameId(i.id, selectedStreetId)) || null

  return (
    <>
      <Grid item md={6} xs={12}>
        <FormControl>
          <Autocomplete
            disabled={disabled}
            options={neighborhoods}
            getOptionLabel={option => option.name || ''}
            getOptionSelected={(option, value) => sameId(option.id, value.id)}
            value={selectedNeighborhood}
            onChange={(_, neighborhood) =>
              selectNeighborhood(neighborhood ? neighborhood.id : undefined)
            }
            openText="Abrir"
            closeText="Fechar"
            clearText="Limpar"
            noOptionsText="Nenhum bairro encontrado"
            renderInput={params => (
              <TextField
                {...params}
                label="Selecione o bairro"
                variant="outlined"
              />
            )}
          />
        </FormControl>
      </Grid>

      <Grid item md={6} xs={12}>
        <FormControl>
          <Autocomplete
            disabled={disabled || !selectedNeighborhood}
            options={streets}
            getOptionLabel={option => option.name || ''}
            getOptionSelected={(option, value) => sameId(option.id, value.id)}
            onChange={(_, street) => (street ? choose(street) : clearStreet())}
            openText="Abrir"
            closeText="Fechar"
            clearText="Limpar"
            noOptionsText="Nenhum logradouro encontrado"
            value={selectedStreet}
            renderInput={params => (
              <TextField
                {...params}
                label="Selecione o logradouro"
                variant="outlined"
              />
            )}
          />
        </FormControl>
      </Grid>
    </>
  )
}

export default WeakStreetResults
